import types from './mutations-types';
import { VersionsStateShape } from 'store';

export default {
	[types.SET_CURRENT_VERSION](state: VersionsStateShape, versionValue: number) {
		state.current = versionValue;
	},

	[types.SET_VERSIONS](state: VersionsStateShape, versions = {}) {
		state.versions = versions;
	}
};
